module.exports = __webpack_public_path__ + "static/media/logo.7cf4e361.svg";